import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { isGifUrl, splitUrlQueryParams, joinUrlQueryParams } from '../../../utils/misc-utils.js';

// https://regex101.com/r/jqPxed/1/
const DATA_URL_REGEX = /data:image\/\w+;base64/g;
// https://regex101.com/r/g5PrQG/2
const SRCSET_REGEX = /\S+(?:\s?\S+)?/g;

/**
 * This function appends query params to a single src value as in the src attribute or a string listing many as you
 * might find in a srcSet attribute (see regex101 (https://regex101.com/r/g5PrQG/2) examples).
 */
function appendOutputParams(srcString) {
  const matches = srcString.match(SRCSET_REGEX) || [];
  let srcAuto = [];
  let srcJpg = [];
  matches.forEach(match => {
    const [src, width = ''] = match.split(' ');
    const isGif = isGifUrl(src);
    const isDataUrl = src && src.match(DATA_URL_REGEX);
    const [cleanSrc, paramStrings] = splitUrlQueryParams(src);
    const imgParams = paramStrings.filter(p => !p.includes('output'));
    const jpgOutputParams = isDataUrl ? imgParams : imgParams.concat(['output-format=jpg', 'output-quality=auto']);
    const autoOutputParams = imgParams.concat(['output-format=auto', 'output-quality=auto']);
    srcJpg.push(`${joinUrlQueryParams(cleanSrc, jpgOutputParams)} ${width}`.trim());
    if (!isGif && !isDataUrl) {
      srcAuto.push(`${joinUrlQueryParams(cleanSrc, autoOutputParams)} ${width}`.trim());
    }
  });
  return [srcJpg.join(' '), srcAuto.join(' ')];
}
const Image = _ref => {
  let {
    alt = '',
    fetchpriority = 'auto',
    height = '',
    loading = 'eager',
    sizes = '',
    src = '',
    srcSet = '',
    width = ''
  } = _ref;
  const imageEl = useRef(null);
  const [srcJpg] = appendOutputParams(src);
  const [srcsetJpg, srcsetAuto] = appendOutputParams(srcSet || src);
  return /*#__PURE__*/React.createElement("picture", null, srcsetAuto && /*#__PURE__*/React.createElement("source", {
    srcSet: srcsetAuto,
    sizes: sizes ? sizes : null
  }), /*#__PURE__*/React.createElement("img", {
    alt: alt,
    height: height,
    loading: loading,
    fetchpriority: fetchpriority,
    ref: imageEl,
    sizes: sizes ? sizes : null,
    src: srcJpg,
    srcSet: srcSet ? srcsetJpg : null,
    width: width
  }));
};
Image.propTypes = {
  alt: PropTypes.string,
  fetchpriority: PropTypes.oneOf(['high', 'low', 'auto']),
  height: PropTypes.string,
  loading: PropTypes.oneOf(['eager', 'lazy']),
  sizes: PropTypes.string,
  src: PropTypes.string,
  srcset: PropTypes.string,
  width: PropTypes.string
};

export { Image as default };
